import styled from '@emotion/styled';

interface TagInputProps {
  width: number;
  height: number;
}

export const TagInput = styled.input<TagInputProps>`
  width: ${props => `${props.width}px`};
  height: ${props => `${props.height}px`};
  text-align: center;
`;
